import {
  EInvitationStatus,
  IInvitation,
  useSnackbarNotification,
  useInviteClient,
  JupiterTheme,
  useAsyncEffect,
} from '@jupiterone/jupiter-web-toolkit';
import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import styles from 'navbar/src/jupiterAccountSettings/AccountSettings/AccountPage.styles';
import InvitationList from './InvitationList';

interface Props {
  notification: ReturnType<typeof useSnackbarNotification>;
}

const useStyles = makeStyles((theme: JupiterTheme) => styles(theme));

export const useInvitationPageLogic = ({ notification }: Props) => {
  const inviteClient = useInviteClient();
  const [invitations, setInvitations] = useState<IInvitation[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useAsyncEffect(async () => {
    if (inviteClient.loading) {
      return;
    }
    const invitations = await getPendingInvitations();
    setInvitations(invitations);
    setLoading(false);
  }, [inviteClient.loading]);

  const handleInviteAction = async (id: string, action: EInvitationStatus) => {
    try {
      await inviteClient.inviteAction(id, action);
      const filteredInvites = invitations.filter(
        (i: IInvitation) => i.id !== id
      );
      setInvitations(filteredInvites);
    } catch (_err) {
      notification.error({
        message: 'Failed to update invitation status',
        error: _err,
      });
    }
  };

  const getPendingInvitations = async (): Promise<IInvitation[]> => {
    try {
      const response = await inviteClient.getInvitations();
      return response.items.filter((invitation) => {
        return invitation.status === EInvitationStatus.pending;
      });
    } catch (_err) {
      notification.error({
        message: 'Failed to get pending invitations',
        error: _err,
      });
    }
    return [];
  };
  return {
    loading: loading && inviteClient.loading,
    handleInviteAction,
    invitations,
  };
};

const InvitationPage = ({ notification }: Props) => {
  const classes = useStyles();
  const { loading, handleInviteAction, invitations } = useInvitationPageLogic({
    notification,
  });

  if (loading) {
    return (
      <div className={classes.spinnerCenter}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <InvitationList
      onInviteAction={handleInviteAction}
      invitations={invitations}
    />
  );
};

export default InvitationPage;
